import { useEffect, useState, type RefObject } from "react";

/**
 * Eleman görünür alana `rootMargin` kadar yaklaştığında true olur ve öyle kalır.
 * Kart videolarının kaynağını ekran dışındayken indirmemek için kullanılır.
 */
export const useNearViewport = (
  ref: RefObject<Element | null>,
  { rootMargin = "400px", enabled = true }: { rootMargin?: string; enabled?: boolean } = {}
) => {
  const [isNear, setIsNear] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!enabled || isNear || !element) return;
    if (typeof IntersectionObserver === "undefined") {
      setIsNear(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setIsNear(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [enabled, isNear, ref, rootMargin]);

  return isNear;
};
